// extracted by mini-css-extract-plugin
export default {"container":"category_container__rbs9u","name":"category_name__c4Wwq","edit":"category_edit__NIBGH"};